import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { GATE_QUERY_KEY, fetchGate } from '@/pages/LicenseExpired';

/**
 * Route-level lisans koruması: lisans geçersizse kullanıcı NEREDE olursa olsun
 * /license-expired'a yönlendirilir (uygulama kabuğu hiç render edilmez). Sunucu
 * tarafı 402 kapısıyla birlikte çalışır; merkez ulaşılamazsa (blocked=false) açık kalır.
 */
export default function LicenseGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const q = useQuery({ queryKey: GATE_QUERY_KEY, queryFn: () => fetchGate(), refetchInterval: 5 * 60_000, staleTime: 60_000, retry: false });

  if (q.isLoading && !q.data) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-gray-700" /></div>;
  }
  if (q.data?.blocked && !location.pathname.startsWith('/license-expired')) {
    return <Navigate to="/license-expired" replace />;
  }
  return <>{children}</>;
}
